import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'enable-clients-opt-in',
	template: require('./enable-clients-opt-in.html')
})
export class EnableClientsOptInComponent {
	@Input() showOtpInConsent: boolean;
	@Input() id: any;
	@Output() showOptIn: EventEmitter<boolean> = new EventEmitter();

	constructor() {}

	changeOptStatus() {
		this.showOtpInConsent = !this.showOtpInConsent;
		this.showOptIn.emit(this.showOtpInConsent);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./web/modern/components/client/enable-clients-opt-in/enable-clients-opt-in.ts